import NotificationBar from './NotificationBar.vue';

export default NotificationBar;
